import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './MessageBox.module.css';

export enum MessageBoxType {
  Info = 'info',
  Error = 'error',
  Warning = 'warning',
  Success = 'success'
}

export type MessageBoxProps = ComponentProps<'div'> & {
  type?: MessageBoxType;
};

export const MessageBox: FunctionComponent<MessageBoxProps> = React.memo(
  (props) => {
    const {
      className,
      type = MessageBoxType.Info,
      children,
      ...remainingProps
    } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(
          className,
          styles.messageBox,
          messageBoxTypeToClassName[type]
        )}
      >
        {children}
      </div>
    );
  }
);

const messageBoxTypeToClassName: Record<MessageBoxType, string | null> = {
  error: styles.messageBoxError,
  info: styles.messageBoxInfo,
  warning: styles.messageBoxWarning,
  success: styles.messageBoxSuccess
};
